/**
 * JSON utility module for renderer
 */
define("tmds/utils/rendererUtils", [
	"tmds/renderers/SimpleRenderer",
	"tmds/renderers/UniqueValueRenderer",
	"tmds/utils/symbolUtils"
], function(SimpleRenderer, UniqueValueRenderer, symUtils) {
	"use strict";
	
	/**
	 * create renderer object from a JSON representation
	 * @param rendererJson {Object} a renderer in JSON representation
	 * @return {tmds.renderers.Renderer}
	 */
	function fromJson(rendererJson) {

		if (rendererJson && rendererJson.type) {
			switch (rendererJson.type) {
				case "SimpleRenderer":
					return new SimpleRenderer(rendererJson);
					break;
				case "UniqueValueRenderer":
					return new UniqueValueRenderer(rendererJson);
					break;
			}
		}
		throw new Error('Invalid Renderer data ' + rendererJson + ' passed.');
	}

	/**
	 * create default renderer based on the spatial type
	 * @param type {String} Point | Line | Polyline
	 * @return {tmds.renderers.SimpleRenderer}
	 */
	function fromSpatialType(type) {
		return new SimpleRenderer({
			symbol: symUtils.fromSpatialType(type)
		});
	}
	
	var utils = {
		'fromJson' : fromJson,
		'fromSpatialType' : fromSpatialType
	};
	
	return utils;
});